var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"0 auto","width":"1000px"}},[_c('Transfer',{attrs:{"data":_vm.userList,"target-keys":_vm.targetKeys,"list-style":_vm.listStyle,"render-format":_vm.renderFormat,"titles":['所有成员','本团队成员'],"operations":['移除','添加'],"filterable":"","filter-method":_vm.filterMethod},on:{"on-change":_vm.handleChange}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-089cbd97","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/team/teamUser.vue
// module id = null
// module chunks = 